import React from "react";
import { Link } from "react-router-dom";
const Footer = () => {
  const skillsData = [
    {
      role: "Administrator",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747313147/CareerPath_Administrator-BjHmPKQu_v1d9be.png",
      description: "Manages system settings and access.",
    },
    {
      role: "AI Engineer",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314025/CareerPath_AI_20Engineer-D3sD5biC_une0xr.png",
      description: "Develops AI models and solutions.",
    },
    {
      role: "App Maker",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314082/CareerPath_App_20Maker-DJrS4pdl_fupr4m.png",
      description: "Builds apps using low-code tools.",
    },
    {
      role: "Business User",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314126/CareerPath_BusinessUser-ZGqJURcj_wfxqnk.png",
      description: "Improves workflows with digital tools.",
    },
    {
      role: "Data Analyst",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314281/CareerPath_DataAnalyst-DsDLhK5n_uyujeo.png",
      description: "Analyzes data to uncover trends.",
    },
    {
      role: "Data Engineer",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314240/CareerPath_DataEngineer-VVR6q-Aq_xvewab.png",
      description: "Prepares and manages data pipelines.",
    },
    {
      role: "Data Scientist",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314403/CareerPath_DataScientist-s2IzO17O_hbd9yu.png",
      description: "Extracts insights using data models.",
    },
    {
      role: "Developer",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314424/CareerPath_Developer-Dblq_kTd_rxbc1q.png",
      description: "Writes code and builds software.",
    },
    {
      role: "DevOps Engineer",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314464/CareerPath_DevOpsEngineer-CDg1E5cB_xgz5vk.png",
      description: "Automates and integrates deployments.",
    },
    {
      role: "Functional Consultant",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314511/CareerPath_FunctionalConsultant-DY4IyiAb_smu3f7.png",
      description: "Aligns tech solutions with business needs.",
    },
    {
      role: "Identity Administrator",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314533/CareerPath_IdentityAccessAdmin-DBS2cag7_wlzuhi.png",
      description: "Manages user identities and permissions.",
    },
    {
      role: "Information Administrator",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314584/CareerPath_InfoProtectionAdmin-BEkoXDCz_vqtaeg.png",
      description: "Secures and manages information access.",
    },
    {
      role: "Security Engineer",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314629/CareerPath_SecurityEngineer-CDvGevEB_rp84qc.png",
      description: "Implements security solutions and policies.",
    },
    {
      role: "Security Operations Analyst",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314629/CareerPath_SecurityEngineer-CDvGevEB_rp84qc.png",
      description: "Monitors and responds to threats.",
    },
    {
      role: "Security Architect",
      image:
        "https://res.cloudinary.com/dbitupkaa/image/upload/v1747314671/CareerPath_SolutionArchitect-BTtyYYMD_k5sefj.png",
      description: "Designs enterprise-level security systems.",
    },
  ];

  return (
    <footer className="relative z-10 border-t-2 border-gray-100 pt-4 font-Questrial bg-white">
      <div className="mx-auto px-4">
        <div className="flex flex-wrap -mx-4">
          {/* About Us */}
          {/* <div className="w-full px-4 sm:w-2/3 lg:w-3/12">
            <div className="w-full lg:ml-10">
              <h4 className="text-sm font-semibold text-[#5c68f2]">About Us</h4>
              <p className="text-sm text-black mb-4">
                Rent diverse Cloud and AI tech experts on a pay-as-you-go basis
                with us. We manage the complexity while you innovate, securely.
              </p>
            </div>
          </div> */}
          {/* About Us */}
          <div className="w-full px-4 sm:w-2/3 lg:w-3/12">
            <div className="w-full lg:ml-10">
              <h4 className="text-sm font-semibold text-[#5c68f2]">About Us</h4>
              <p className="text-sm text-black mb-4">
                Rent diverse Cloud and AI tech experts on a pay-as-you-go basis
                with us. We manage the complexity while you innovate, securely.
              </p>

              {/* New: Our Customers and Links */}
              <div className="mt-4">
                <h2 className="text-sm font-semibold text-[#5c68f2] mb-1">
                  Our Customers
                </h2>
                <div className="flex space-x-4 text-sm text-blue-600">
                  <Link
                    to="https://getmax.cloud"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    GetMax.Cloud
                  </Link>
                  <Link
                    to="https://getmax.ae"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hover:underline"
                  >
                    GetMax.AE
                  </Link>
                </div>
              </div>
            </div>
          </div>

          {/* Contact Info */}
          <div className="w-full px-4 sm:w-1/2 lg:w-3/12 mb-4 lg:pl-12">
            <div className="w-full">
              <h4 className="text-sm font-semibold text-[#5c68f2] flex items-center">
                <img
                  src="https://res.cloudinary.com/dbitupkaa/image/upload/v1747659823/india-1617463_640_e6vmfa.png"
                  alt="Indian flag"
                  className="w-8 h-auto mr-2"
                />
                India
              </h4>
              <p className="text-sm mb-2">
                Mahalaxmi Chambers, Darodkar Square, Central Avenue Nagpur –
                440002
              </p>
              <p className="flex items-center text-sm mb-2">
                <span className="mr-2">📞</span>
                +919637760077
              </p>
              <p className="flex items-center text-sm">
                <span className="mr-2">📧</span>
                Email: Monal@navishaa.com
              </p>
            </div>
          </div>

          {/* Tech Skills Section with auto-scrolling */}
          <div className="w-full px-4 sm:w-1/2 lg:w-6/12 mb-4">
            <div className="relative h-full pt-0 mx-auto">
              <h2 className="text-[#5c68f2] text-sm  font-bold text-start font-Barlow mb-2">
                <span>Tech experts skillset includes:</span>
              </h2>

              <div className="overflow-hidden relative ">
                <div className="flex w-max animate-scroll space-x-4">
                  {[...skillsData, ...skillsData].map((skill, idx) => (
                    <div
                      key={idx}
                      className="bg-white rounded-lg shadow-md flex-none border border-gray-200 transform transition duration-300 hover:scale-105 hover:shadow-lg"
                      style={{ width: "180px", height: "120px" }}
                    >
                      <img
                        src={skill.image}
                        alt={`${skill.role} Logo`}
                        className="w-full h-[70px] object-cover rounded-t-lg"
                      />
                      <div className="px-2 py-1 bg-white h-[50px]">
                        <h3 className="text-xs font-semibold text-gray-800 mb-0 truncate">
                          {skill.role}
                        </h3>
                        <p className="text-[10px] text-gray-600 leading-tight break-words line-clamp-2">
                          {skill.description}
                        </p>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="text-center text-[#5c68f2] text-xs md:text-sm py-2 border-t border-gray-200">
        2024 © Navishaa All Rights Reserved.
      </div>

      <style jsx>{`
        @keyframes scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }

        .animate-scroll {
          animation: scroll 40s linear infinite;
        }
      `}</style>
    </footer>
  );
};

export default Footer;
